import { render, staticRenderFns } from "./Favorecido.vue?vue&type=template&id=4664f848&scoped=true&"
import script from "./Favorecido.vue?vue&type=script&lang=js&"
export * from "./Favorecido.vue?vue&type=script&lang=js&"
import style0 from "./Favorecido.vue?vue&type=style&index=0&id=4664f848&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4664f848",
  null
  
)

export default component.exports